import { Link, useLocation } from "react-router-dom";

export const Footer = () => {
  const location = useLocation();

  const onClick = (e: React.MouseEvent) => {
    if (location.pathname === "/") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const onContactClick = (e: React.MouseEvent) => {
    if (location.pathname === "/contact-us") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };
  return (
    <div className="footer">
      <Link to="/" onClick={onClick}>
        CHARPROOF @ 2025
      </Link>

      <Link to="/contact-us" onClick={onContactClick}>
        Contact Us
      </Link>
    </div>
  );
};
